import { useMemo } from 'react';
import ReactTooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

import Icon from './Icon';

const Tooltip = ({
    text,
    placement = 'top',
    trigger,
    delayShow = 200,
    delayHide = 200,
    triggerClass = '',
    tooltipClass = '',
    children,
}) => {
    const triggerElement = useMemo(() => {
        return children || <Icon icon='Help' className='fs-5 ms-1 d-block' />;
    }, [children]);

    return (
        <OverlayTrigger
            delay={{ show: delayShow, hide: delayHide, }}
            overlay={(props) => (
                <ReactTooltip {...props}>
                    <span className={tooltipClass}>{text}</span>
                </ReactTooltip>
            )}
            placement={placement}
            trigger={trigger}
        >
            <span className={`d-block ${triggerClass}`}>
                {triggerElement}
            </span>
        </OverlayTrigger>
    );
};

export default Tooltip;